import { makeRequest } from 'utils/requestLogger';

export default (profileID, commentID) =>
  makeRequest('put', `/api/comments/${commentID}/toggle-flag`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/flagComment.js